import "./App.css";
import React, {useContext} from "react";
import ContactPage from "./pages/ContactPage/ContactPage";
import InstallationPage from "./pages/InstallationPage/InstallationPage";
import MachinesPage from "./pages/MachinesPage/MachinesPage";
import SummaryPage from "./pages/SummaryPage/SummaryPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage/OrderConfirmationPage";
import Header from "./components/Header/Header";
import Navbar from "./components/Navbar/Navbar";
import {AppContext} from "./context/AppContext";
import {FormProvider} from "./context/FormContext";
import {DrumConfigurationProvider} from "./context/DrumConfigurationContext";

const App = () => {
    const {currentPage} = useContext(AppContext);

    const renderSubpage = () => {
        switch (currentPage) {
            case 0:
                return <ContactPage/>;
            case 1:
                return <InstallationPage/>;
            case 2:
                return <MachinesPage/>;
            case 3:
                return <SummaryPage/>;
            case 4:
                return <OrderConfirmationPage/>;
            default:
                return <ContactPage/>;
        }
    };

    return (
        <div className="App">
            <div>
                <Header/>
                <div className="main-card">

                    {currentPage !== 4 && <Navbar/>}

                    <DrumConfigurationProvider>
                        <FormProvider>
                            <main>{renderSubpage()}</main>
                        </FormProvider>
                    </DrumConfigurationProvider>
                </div>
            </div>
        </div>
    );
};

export default App;
